module.exports = __webpack_public_path__ + "static/media/08.Stage Set up.af9e7792.JPG";